import { EntityRequestHoliday } from "../../entity/EntityRequestHoliday";

export class DtoRequestHolidaysPutRes extends EntityRequestHoliday {}
